<script lang="ts">
  import { parse } from "regexparam";
  import { getContext, onMount } from "svelte";
  import { get } from "svelte/store";
  import { normalizeRelative } from "../src/path";
  import type { RouteNode } from "../src/route";
  import { router } from "../src/router";

  export let path: string;
  export let to: string;

  let matcher = parse(normalizeRelative(path));
  let parent = (getContext("route") || router) as RouteNode;

  $: absoluteToPath = parent.generatePath(to);

  onMount(() => {
    return router.subscribe(() => {
      if (matcher.pattern.test(get(parent.currentPath))) {
        router.goto(absoluteToPath, { replace: true });
      }
    });
  });
</script>
